// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: `Ya existe un diseño de página con este nombre`,
    ACCEPT: `Aceptar`,
    ACCEPT_ALL: `Aceptar Todos`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Aprobación pendiente`,
    ACCEPTED: `Aceptado`,
    ACCOUNT: `Cuentas`,
    ACCOUNT_ADDRESS: `Dirección de Concesión`,
    ACCOUNT_COUNTRY: `País del concesionario`,
    ACCOUNT_END: `Fin de cuenta`,
    ACCOUNT_NAME: `Nombre del concesionario`,
    ACCOUNT_NUMBER: `Número de cuenta`,
    ACCOUNT_NUMBER_REQUIRED: `Se Requiere Nº Cuenta de Concesión`,
    ACCOUNTS: `Cuentas`,
    ACCUMULATED_DAYS_ON_RENT: `Días de Alquiler Acumulados`,
    ACCUMULATED_DAYS_RENTED: `Días de Alquiler Acumulado`,
    ACTIONS: `Acciones`,
    ACTIVE_WARRANTY: `Garantía Activa`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL: `Garantía Activa (Hacer clic para conocer los detalles)`,
    ACTIVE_WARRANTY_Y_N: `Garantía activa (S/N)`,
    ACTUAL_AMOUNT_OF_USE: `Cantidad Real de Uso`,
    ACTUAL_AUDIT: `Auditoría Real`,
    ACTUAL_AUDIT_DATE: `Fecha de auditoría real`,
    ACTUAL_COURIER_NAME: `Nombre del Servicio de Mensajería Real`,
    ACTUAL_H: `Horas Reales`,
    ACTUAL_HOURS: `Horas Reales`,
    ACTUAL_PC:`Pacas reales`,
    ADD_CLAIM: `Agregar Reclamación`,
    ADD_CLAIMS: `Agregar Reclamaciones`,
    ADD_COMPONENT: `Add Component`,
    ADD_OPTION: `Añadir Opción`,
    ADD_REP: `Reparo Adicional`,
    ADD_TO_AUDIT: `Agregar a Auditoría`,
    ADDITIONAL: `Adicional`,
    ADDITIONAL_COMMENTS: `Comentarios Adicionales`,
    ADDITIONAL_REPAIR: `Reparo Adicional`,
    ADDITIVE: `Suplementario`,
    ADDRESS: `Dirección`,
    ADDRESS_LINE1: `Línea de dirección 1`,
    ADDRESS_LINE1_REQUIRED: `Se requiere la línea 1 de dirección`,
    ADDRESS_LINE2: `Línea de dirección 2`,
    ADJ_CLM: `Ajustar Reclamación`,
    ADJUST_CLAIM: `Ajustar Reclamación`,
    ADJUSTED_HOURS: `Horas ajustadas`,
    ADJUSTED_QUANTITY: `Cantidad ajustada`,
    ADJUSTMENT_TYPE: `Tipo de Ajuste`,
    ADVANCED_CLAIM_SUMMARY: `Avanzado Resume de Reclamación`,
    AFTER_DELIVERY_INSPECTION: `LUEGO DE LA INSPECCIÓN DE ENTREGA`,
    AGENCY_NAME: `Nombre de Agencia`,
    ALL: `Todos`,
    ALL_ACCOUNTS: `Todas las Cuentas`,
    ALL_CLAIMS: `Todas las Reclamaciones`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: `Todas las reclamaciones están sujetas a revisión (ver JD WAM 110.08 para más información)`,
    ALL_CLAIMS_TAB: `Todas las Reclamaciones ({count, number})`,
    ALL_PART_REQUESTS: `Todas las Solicitudes de Piezas`,
    ALL_PART_REQUESTS_WITH_COUNT: `Todas las Solicitudes de Piezas ({count})`,
    ALL_PARTS_RETURNED: `Todas las Piezas Devueltas`,
    AMOUNT: `Monto`,
    AMOUNT_1: `Monto 1`,
    AMOUNT_2: `Monto 2`,
    AMOUNT_3: `Monto 3`,
    AMOUNT_OF_USE: `Horas de Trabajo`,
    AMOUNT_OF_USE_ACCEPETD: `Cantidad de uso aceptado`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Cantidad de uso creado correctamente`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT: `Cantidad de Historial de Uso ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED: `El campo Cantidad de Uso es requerido.`,
    AMOUNT_OF_USE_REJECTED: `Cantidad de uso rechazada`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `Estado de solicitudes de cantidad de uso`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Cantidad de solicitudes de uso ({count})`,
    AMOUNT_OF_USE_REQUIRED: `Cantidad de uso requerido`,
    AMOUNT_OF_USE_UNITS_REQUIRED: `Cantidad de unidades usadas requeridas`,
    AMOUNT_RECORDED: `Cantidad Registrada`,
    AMOUNT_TO_BE_DEBITED: `Cantidad que se debe debitar`,
    APLYPIP: `Aplicar PIP`,
    APPLICATION: `Aplicación`,
    APPLICATION_IS_REQUIRED: `El campo Aplicación es requerido.`,
    APPLY: `Aplicar`,
    APPLY_TRAVEL: `Aplicar Viaje`,
    APPROVAL_DEALER_COMMENTS: `Comentarios de Aprobación de Concesión/Distr.`,
    APPROVAL_DETAILS: `Detalles de Aprobación`,
    APPROVAL_LEVELS: `Niveles de aprobación`,
    APPROVAL_REMARKS: `Observaciones de aprobación`,
    APPROVAL_STATUS: `Estado de aprobación`,
    APPROVE: `Aprobar`,
    APPROVE_AMOUNT_OF_USE: `Aprobar cantidad de uso`,
    APPROVE_LABOR_RATE: `Aprobar Tarifa de Mano de Obra`,
    APPROVE_MACHINE_STATUS_UPDATE: `Aprobar Actualización de Estado de Máquina`,
    APPROVE_PIP_CODE_REQUEST: `Aprobar Solicitud de código PIP`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM: `Aprobar Reclamación de Asignación Especial`,
    APPROVED: `Aprobada`,
    APPROVED_CORE_VALUE: `Valor Material Aprobado`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: `La fecha de aprobación no puede ser anterior a la fecha de configuración.`,
    APPROVED_DIAGNOSTIC_AMOUNT: `Monto de diagnóstico aprobado`,
    APPROVED_DIAGNOSTIC_HOURS: `Horas de diagnóstico aprobadas`,
    APPROVED_IS_REQUIRED: `El campo Aprobado es obligatorio.`,
    APPROVED_LABOR_ADDITIVE: `Suplementario de Mano de Obra Aprobada`,
    APPROVED_LABOR_AMOUNT: `Cantidad de Mano de Obra Aprobada`,
    APPROVED_LABOR_HOURS: `Horas de Mano de Obra Aprobadas`,
    APPROVED_LABOR_TOTAL: `Total de Mano de obra Aprobada`,
    APPROVED_ON_SHELF_COST: `Costo del estante aprobado`,
    APPROVED_OTHER_CREDITS: `Otros Créditos Aprobados`,
    APPROVED_PARTS: `Piezas Aprobadas`,
    APPROVED_PARTS_ADDITIVE: `Aditivo de partes está aprobado`,
    APPROVED_PARTS_TOTAL: `Total de partes aprobadas`,
    APPROVED_REJECTED: `Aprobado/Rechazado`,
    APPROVED_REPAIR_AMOUNT: `Monto de reparación aprobada`,
    APPROVED_REPAIR_HOURS: `Horas de reparación aprobadas`,
    APPROVED_TAXES_TOTAL: `Total de impuestos aprobados`,
    APPROVED_TRAVEL_TOTAL: `Total de viajes aprobado`,
    APPROVER: `Aprobador`,
    ASCENDING: `Ascendente`,
    ATTACHMENTS: `adjunción`,
    AUDIT_NUMBER: `Número de Auditoría`,
    AUDIT_PLANNED: `Auditoría Planificada`,
    AUDIT_REQUIREMENT: `Requisito de Auditoría`,
    AUDIT_RESULTS: `Resultados de auditorías`,
    AUDIT_STATUS: `Estado de la Auditoría`,
    AUDIT_SUBMITTED_SUCCESSFULLY: `Auditoría enviada con éxito`,
    AUDIT_SUMMARY: `Resumen de Auditoría`,
    AUDIT_TYPE: `Tipo de Auditoría`,
    AUDITS: `Auditorías`,
    AUDITS_DUE_WITH_COUNT: `{countToDisplay} auditorías previstas`,
    AUDITS_DUE_WITHIN_30_DAYS: `{countToDisplay} {count, plural, one {audit} other {audits}} previstas dentro de los 30 días`,
    AUDITS_PAST_DUE_WITH_COUNT: `{countToDisplay} {count, plural, one {audit} other {audits}} atrasadas`,
    AUTHORIZATION_NUMBER: `Nº de Autorización`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: `Enviar Automáticamente desde el Sistema Comercial del Concesionario`,
    AVAILABLE: `Disponible`,
    AVAILABLE_COLUMNS: `Columnas Disponibles`,
    AVERAGE_DIAGNOSTICS_HOURS: `Horas de Diagnóstico Promedio`,
    AVERAGE_LUG_HEIGHT: `Altura promedio del callo`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED: `El campo Altura Promedio de las Salientes es obligatorio.`,
    AVERAGE_REPAIR_HOURS: `Horas de Reparación Promedio`,
    AVERAGE_REPLACEMENT_HOURS: `Horas de Reemplazo Promedio`,
    AVERAGE_TECH_PAY_RATE: `tasa promedio de mano de obra técnica`,
    BACK: `Regresar`,
    BACK_TO_AUDIT: `Volver a Auditoría`,
    BASE_MACHINE: `Base de Maquina`,
    BASE_MACHINE_IMPLEMENTS: `Aperos de la máquina básica`,
    BASE_MACHINE_PIN: `PIN de la máquina base`,
    BASIC_WARRANTY_ENDS: `Finalización de la Garantía Básica`,
    BASIC_WARRANTY_ESTIMATOR: `Estimador básico de la garantía`,
    BASIC_WARRANTY_STARTS: `Inicio de la Garantía Básica`,
    BASIS_FOR_SETTLEMENT: `Bases para el arreglo`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Bases para el arreglo / Comentarios de auditoría`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED: `Bases para el arreglo se requiere.`,
    BATTERY: `Batería`,
    BEGIN_DATE: `Fecha de Inicio`,
    BRANCH: `Sucursal`,
    BUILT: `Crear`,
    BUSINESS_END: `Fin de la empresa`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE:`¿Es posible poner nuevamente en funcionamiento la máquina?`,
    CANCEL: `Cancelar`,
    CERTIFIED_LETTER_SENT: `Carta Certificada Enviada`,
    CGST: `CGST`,
    CHANGE_RESPONSIBLE_DEALER: `Cambiar la concesión responsable`,
    CHANGE_STATUS: `Cambiar Estatus`,
    CHANGE_STATUS_FOR: `Cambiar Estado para {pin}`,
    CHANGED: `Cambiado`,
    CHANGED_BY: `Actualizado Por`,
    CHANGED_ON: `Cambio En`,
    CHINESE: `Chino`,
    CITY: `Ciudad`,
    CITY_REQUIRED: `Ciudad requerida`,
    CLAIM: `Reclamación`,
    CLAIM_COUNT_WITH_PARENTHESIS: `({countToDisplay} {count, plural, one {Reclamación} other {Reclamaciones}})`,
    CLAIM_DEBIT: `Reclamar Débito`,
    CLAIM_DETAILS: `Detalles de la Reclamación`,
    CLAIM_DRAFT: `BORRADOR`,
    CLAIM_HISTORY: `Historial de reclamaciones de 24 meses`,
    CLAIM_HISTORY_WITH_COUNT: `Historial de reclamaciones de 24 meses ({count})`,
    CLAIM_NUMBER: `Nº de Reclamación`,
    CLAIM_RECOVER_PERCENTAGE: `({percentage}%)`,
    CLAIM_SEARCH: `Búsqueda de Reclamación`,
    CLAIM_STATUS: `Estado de las Reclamaciones`,
    CLAIM_TYPE: `Tipo de Reclamación`,
    CLAIM_TYPES: `Tipos de Reclamaciones`,
    CLAIM_UPDATED_SUCCESSFULLY: `Reclamo actualizado con éxito`,
    CLAIM_VALUE: `Valor de la Reclamación`,
    CLAIM_VALUE_DETAILS: `Detalles del Valor de la Reclamación`,
    CLAIM_WITH_NUMBER: `Reclamación {claimNumber}`,
    CLAIMS: `Reclamaciones`,
    CLAIMS_IN_PROGRESS: `Reclamaciones En Progreso`,
    CLAIMS_IN_PROGRESS_WITH_COUNT: `Reclamaciones En Progreso ({count})`,
    CLAIMS_OVERVIEW: `Descripción General de las Reclamaciones`,
    CLAIMS_OVERVIEW_TAB: `Descripción General de las Reclamaciones {count}`,
    CLAIMS_WITH_COUNT: `{count} Reclamaciones`,
    CLICK_FOR_DETAILS: `(Haga clic para obtener detalles)`,
    CLICK_TO_VIEW_ALL: `Haga clic para Ver Todo`,
    CLOSE: `Cerrar`,
    CLOSED_PART_REQUESTS: `Solicitudes de partes cerradas`,
    CLOSING: `Cierre`,
    CLOSING_ACCOUNT: `Cuenta de cierre`,
    CLOSING_ACCOUNT_WITH_COUNT: `Cuenta de cierre ({count})`,
    CODE: `Código`,
    COLLAPSE_ALL: `Contraer Todo`,
    COMMENT: `Comentario`,
    COMMENTS: `Comentarios`,
    COMMENTS_IS_REQUIRED: `Comentarios son obligatorio.`,
    COMMENTS_TO_DEALER: `Comentarios al concesionario`,
    COMMON_LABOR_TYPES_WARNING: `No todos los tipos de mano de obra disponibles para las cuentas seleccionadas`,
    COMPANY: `Empresa`,
    COMPANY_CONTRIBUTION: `Contribución de Compañía`,
    COMPANY_CONTRIBUTION_IS_REQUIRED: `Contribución de Empresa es obligatorio.`,
    COMPLAINT_CAUSE: `¿Cuál fue el diagnóstico de la queja?`,
    COMPLAINT_CAUSE_IS_REQUIRED: `Se requiere diagnóstico de quejas.`,
    COMPLAINT_CORRECTION: `¿Cómo se reparó la queja?`,
    COMPLAINT_CORRECTION_IS_REQUIRED: `Se requiere reparación de la queja.`,
    COMPLETE: `Completo`,
    COMPLETED: `Realizado`,
    COMPLETED_BY: `Realizado en`,
    COMPLETED_DATE: `Fecha completada`,
    COMPLETED_IN_LAST_24_MONTHS: `Completado en los Últimos 24 Meses`,
    COMPLETION_STATUS: `Estado de Finalización`,
    COMPONENT: `Componente`,
    COMPONENT_CODE: `Component Code`,
    COMPONENT_CREATED_SUCCESSFULLY: `Component Created Successfully`,
    COMPONENT_DELETED_SUCCESSFULLY: `Component Deleted Successfully`,
    COMPONENT_SERIAL_NUMBER: `Número de Serie de Componente`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Componente actualizado con éxito`,
    COMPONENTS: `Componentes`,
    CONFIRM: `Confirmar`,
    CONFIRM_ADDITIONAL_REPAIR: `¿Está seguro de que desea añadir una reparación adicional?`,
    CONFIRM_ADJUST_CLAIM: `¿Está seguro de que desea ajustar esta Reclamación?`,
    CONFIRM_CLOSING_ACCOUNT: `¿Está seguro de que desea aceptar esta transferencia?`,
    CONFIRM_COPY_CLAIM: `¿Está seguro de que quiere copiar la Reclamación?`,
    CONFIRM_DELETE_ATTACHMENT: `¿Seguro que quieres borrar el archivo adjunto?`,
    CONFIRM_DELETE_CLAIM: `¿Está seguro de que quiere eliminar esta Reclamación?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE: `¿Está seguro de que desea eliminar esta solicitud de estado de máquina?`,
    CONFIRM_DELETE_REGISTRATION: `¿Está seguro de que quiere eliminar este Registro?`,
    CONFIRM_EDIT_CLAIM: `¿Está seguro de que quiere editar esta Reclamación?`,
    CONFIRM_RECONCILE_CLAIM: `¿Está seguro de que desea reconciliar esta Reclamación?`,
    CONFIRM_RESEND_XML: `¿Está seguro de que desea volver a enviar XML? Deje 24-48 horas para que sea visible.`,
    CONFIRM_SKIP_AUDIT: `¿Está seguro de que quieres saltearte esta auditoría?`,
    CONFIRM_UNDO_REGISTRATION: `¿Está seguro de que desea anular este registro?`,
    CONFIRM_UNRECONCILE_CLAIM: `¿Está seguro de que desea anular la conciliación de esta reclamación?`,
    CONNECTED_MACHINE: `Máquina conectada`,
    CONTACTED: `Contactado`,
    CONTAINS: `Contiene`,
    CONTRACT_NUMBER: `Número de Contrato`,
    CONTRACT_PURCHASED: `Contrato Adquirido`,
    CONTRACT_TYPE: `Tipo de Contrato`,
    COPY_CLAIM: `Copiar Reclamación`,
    CORE: `Competencias`,
    CORE_VALUE: `Valor de Núcleo`,
    COUNTRY: `País`,
    COUNTRY_REQUIRED: `País requerido`,
    COURIER_ACCOUNT_NUMBER: `Número de Cuenta del Servicio de Mensajería`,
    COURIER_NAME: `Nombre de Transportista`,
    COVERAGE_DECISION: `Decisión de cobertura`,
    COVERAGE_TYPE: `Tipo de cobertura`,
    CRDMEM: `Nota de Credito`,
    CREATE: `Crear`,
    CREATE_CLAIM: `Crea Reclamación`,
    CREATE_LAYOUT: `Creatar Diseño de página`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT: `Antes de poder presentar una reclamación sobre este producto, debe informarnos alguna información importante sobre el mismo`,
    CREATE_PIP_CLAIM: `Crear Reclamacion de PIP`,
    CREATE_PIP_CLAIMS: `Crear Reclamaciones de PIP`,
    CREATE_PRODUCT_RECORD: `Crear Registro del Producto`,
    CREATE_REQUEST: `Crear solicitud`,
    CREATE_TRANSFER_PENDING: `Transferencia pendiente`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE: `Crear Servicios de Transferencia No Disponible`,
    CREATED: `Creado`,
    CREATED_BY: `Creado por`,
    CREATED_DATE: `Fecha de Creación`,
    CREATED_DATE_FROM: `Desde la fecha de creación`,
    CREATED_DATE_TO: `Hasta fecha de creación`,
    CREATED_ON: `Creado el`,
    CREATION_DATE: `Fecha de Creación`,
    CREDIT_MEMO: `Nota de Crédito`,
    CREDIT_MEMO_DATE: `Fecha de la nota de crédito`,
    CREDIT_MEMO_ISSUE_DATE: `Nota de crédito emitida`,
    CREDIT_MEMO_NUMBER: `Número de la nota de crédito`,
    CREDIT_MEMO_PROCESS_DATE: `Nota de Crédito Procesado`,
    CREDIT_MEMO_SELECTED: `Nota de Crédito Seleccionada`,
    CREDIT_MEMOS: `Notas de crédito`,
    CRITERIA: `Criterios`,
    CRT: `Crear`,
    CSV_SEPARATOR: `Separador CSV`,
    CURRENCY: `Moneda`,
    CURRENT: `Presente`,
    CURRENT_ACCOUNT: `Cuenta corriente`,
    CURRENT_AMOUNT_OF_USE: `Horas de Trabajo Actuales`,
    CURRENT_CUSTOMER: `Cliente Actual`,
    CURRENT_DEALER: `Concesionario/Distr Actual`,
    CURRENT_DEALER_DISTANCE: `Distancia actual del concesionario`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Última fecha de servicio del concesionario actual`,
    CURRENT_DEALER_LOCATION: `Ubicación Actual del Concesionario`,
    CURRENT_HOURS: `Horas actuales`,
    CURRENT_QUANTITY: `Cantidad actual`,
    CURRENT_RESPONSIBLE_DEALER: `Concesionario Responsable Actual`,
    CURRENT_VALUES: `Valores Actuales`,
    CURRENTLY_ON_RENT: `Actualmente en Alquiler`,
    CUSTOM_RANGE: `Personalizar Rango`,
    CUSTOM_VALUES: `Valores Personalizados`,
    CUSTOMER: `Cliente`,
    CUSTOMER_CONTRIBUTION: `Contribución de Cliente`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED: `Contribución del Cliente es obligatorio.`,
    CUSTOMER_CREATED_SUCCESSFULLY: `Cliente creado con éxito`,
    CUSTOMER_DETAILS: `Datos de Cliente`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: `Detalles del cliente actualizados correctamente`,
    CUSTOMER_INFORMATION: `Información al cliente`,
    CUSTOMER_INFORMATION_IS_REQUIRED: `Se requiere información del cliente.`,
    CUSTOMER_INVALID: `El cliente no se ha encontrado o creado, por favor, la búsqueda de un cliente`,
    CUSTOMER_NAME: `Nombre de Cliente`,
    CUSTOMER_NAME_IS_REQUIRED: `Se requiere información del cliente.`,
    CUSTOMER_NOT_FOUND: `Cliente No Encontrado`,
    CUSTOMER_PROFILE: `Perfil del Cliente`,
    CUSTOMER_REQUIRED: `Cliente requerido`,
    CUSTOMER_RESOLUTION: `Resolución del Cliente`,
    CUSTOMER_RESOLUTION_IS_REQUIRED: `Resolución del Cliente es obligatorio.`,
    CUSTOMER_SEARCH: `Búsqueda de Cliente`,
    CUSTOMER_UPDATED_SUCCESSFULLY: `Cliente actualizado correctamente`,
    DAMAGED_MACHINES_HELP_TEXT:`En cuanto a las máquinas dañadas, la garantía se suspenderá automáticamente hasta que el TCSM (Gerente de Soporte al Cliente de Territorio) revise y apruebe este formulario para restablecerla. Las máquinas dañadas solo califican para Programas Obligatorios y PIP de Seguridad.`,
    DATE: `Fecha`,
    DATE_FORMAT: `Formato de Fecha`,
    DATE_ISSUED: `Fecha Emitida`,
    DATE_OF_CERTIFIED_LETTER: `Fecha de la Carta Certificada`,
    DATE_OF_EVENT_CAUSING_DAMAGE:`Fecha del evento que provocó el daño`,
    DATE_OF_LAST_PERSONAL_CONTACT: `Fecha del último contacto personal`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT: `Fecha en que la pieza retirada fue enviada/enviada`,
    DATE_REFUSED: `Fecha de Denegación`,
    DATE_SUBMITTED: `Fecha de envío`,
    DAYS_FROM_REGISTRATION: `Días desde el Registro`,
    DAYS_LEFT: `Días Restantes`,
    DAYS_LEFT_WITH_COUNT: `{daysToDisplay} {days, plural, one {Día restante} other {Días restantes}}`,
    DAYS_ON_RENT: `Días Alquilado`,
    DAYS_REMAINING: `Días Restantes`,
    DAYS_REMAINING_WITH_COUNT: `{daysToDisplay} {days, plural, one {Day} other {Days}} Restantes`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {Day} other {Days}} Desde la recomendación`,
    DAYS_TO_DISPLAY: `Días para Mostrar`,
    DBS: `DBS`,
    DEALER: `Concesionario`,
    DEALER_ACCOUNT: `Cuenta de concesionario`,
    DEALER_ACCOUNT_IS_REQUIRED: `Cuenta del Concesionario es obligatorio.`,
    DEALER_ACCOUNTS: `Cuentas de concesionario`,
    DEALER_CITY: `Ciudad de Concesión`,
    DEALER_COMMENTS: `Comentarios del concesionario`,
    DEALER_CONTRIBUTION: `Contribución de Concesión`,
    DEALER_CONTRIBUTION_IS_REQUIRED: `Contribución del Concesionario es obligatorio.`,
    DEALER_HIERARCHY_ACCOUNT: `{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER: `Número de Factura del Concesionario`,
    DEALER_INVOICE_UPDATED: `Factura del Concesionario Actualizada`,
    DEALER_INVOICE_UPDATES: `Factura del Concesionario`,
    DEALER_INVOICES: `Facturas del Concesionario`,
    DEALER_LOCATION: `Ubicación del Concesionario`,
    DEALER_LOCATION_FILTER: `Ubicaciones de los Filtros`,
    DEALER_LOCATION_IS_REQUIRED: `Ubicación del Concesionario es obligatorio.`,
    DEALER_LOCATIONS: `Ubicaciones del Concesionario`,
    DEALER_NAME: `Nombre del distribuidor`,
    DEALER_PHONE: `Nº de Teléfono de Concesión`,
    DEALER_POSTAL_CODE: `Código postal`,
    DEALER_RECOMMENDATIONS: `Recomendaciones del concesionario`,
    DEALER_RECOMMENDATIONS_TAB: `Recomendaciones del concesionario ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Concesionario revisado con éxito`,
    DEALER_SEARCH: `Búsqueda de Concesionario`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: `Ingresar Nombre, Ciudad o Cuenta para buscar concesionarios`,
    DEALER_STATE: `Estado/Provincia de Concesión`,
    DEALER_SUBMISSION_WITH_CURRENCY: `Envío del Concesionario ({currency})`,
    DEALER_TRANSFER_HISTORY: `Historial de transferencia de distribuidores`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Algunas solicitudes de transferencia se crearon correctamente. Procesar el resto individualmente.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Solicitud de transferencia del concesionario en cola correctamente`,
    DEALER_WARRANTY: `Garantía del Concesionario`,
    DEALERS: `Concesionarios`,
    DEALERSHIP: `Concesionario`,
    DEBIT: `Débito`,
    DEBIT_AMOUNT: `Cantidad del Débito`,
    DEBIT_FOR_CLAIM_NUMBER: `Débito para {claimNumber}`,
    DEBIT_REQUIRED: `Débito requerido`,
    DEBIT_REQUIRED_STATUS: `Estado de Débito Requerido`,
    DEBIT_SUBMITTED_SUCCESSFULLY: `Débito enviado con éxito`,
    DEBIT_TYPE: `Tipo de Débito`,
    DEBITED: `Debitado`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: `Los débitos para esta reclamación deben ser completados mediante el proceso de débito manual`,
    DECIMAL_FORMAT: `Formato Decimal`,
    DECISION_UPDATED: `Decisión actualizada`,
    DECLINE: `Rechazar`,
    DEDUCTIBLE: `Franquicia`,
    DEERE_REMARKS: `Comentarios de Deere`,
    DEFAULT_WARRANTY: `Garantía Predeterminada`,
    DEL: `Borrar`,
    DELETE: `Borrar`,
    DELETE_ATTACHMENT: `Eliminar adjunto`,
    DELETE_CLAIM: `Eliminar reclamo`,
    DELETE_MACHINE_STATUS_UPDATE: `Eliminar actualización de estado de la máquina`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS: `Eliminación correcta del estado de la máquina`,
    DELETE_REGISTRATION: `Eliminar Registro`,
    DELETE_REGISTRATION_SUCCESS: `Registro Eliminar con éxito`,
    DELETED: `Eliminado`,
    DELETED_BY: `Eliminado por`,
    DELIVERED: `Entregado`,
    DELIVERED_IS_REQUIRED: `Entregado es requerido.`,
    DELIVERY_DATE: `Fecha de entrega`,
    DELIVERY_DATE_REQUIRED: `Fecha de entrega es requerido.`,
    DELIVERY_DATES: `Fechas de Entrega`,
    DELIVERY_NO_DOCUMENTS: `Entrega Sin Documentos`,
    DEMO_RENTAL_BEGIN_DATE: `Fecha de Incio de Alquiler/Demostración`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS: `Seleccionar Concesionarios y Estado`,
    DEMO_RENTAL_END_DATE: `Fecha de Finalización de Alquiler/Demostración`,
    DEMO_RENTAL_HISTORY: `Historial de Renta Demostración`,
    DENY: `Negar`,
    DENY_AMOUNT_OF_USE: `Denegar cantidad de uso`,
    DENY_MACHINE_STATUS_UPDATE: `Actualización de estado de la máquina de denegación`,
    DENY_PIP_CODE_REQUEST: `Negar Solicitud de código PIP`,
    DESCENDING: `Descendente`,
    DESCRIPTION: `Descripción`,
    DESCRIPTION_OF_DAMAGE:`Descripción del daño`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`Descripción del evento que provocó el daño`,
    DESELECT_ALL: `Deseleccionar todo`,
    DETAILS: `Detalles`,
    DIAGNOSTICS_COVERED: `Diagnóstico Cubierto`,
    DIS_VSR: `Mostrar mensajes`,
    DISPLAY: `Mostrar`,
    DISPLAY_CLAIM: `Mostrar Reclamación`,
    DISPLAY_CREDIT_MEMO: `Mostrar Nota de Crédito`,
    DISPLAY_FORMAT: `Mostrar Formato`,
    DISPLAY_PRODUCT: `Mostrar producto`,
    DISPLAY_TAG: `Mostrar Etiqueta`,
    DISTANCE: `Distancia`,
    DISTANCE_FROM_CURRENT_DEALER: `Distancia desde el concesionario actual`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Distancia desde el concesionario potencial`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Distancia desde la cuenta responsable`,
    DIVISION: `División`,
    DIVISION_SUMMARY: `Resumen de la División`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: `¿Desea guardar los cambios?`,
    DOES_NOT_CONTAIN: `No contiene`,
    DOWNLOAD_TO_EXCEL: `Descargar a Excel`,
    DOWNTIME: `Tiempo de inactividad`,
    DOWNTIME_IS_REQUIRED: `Tiempo de inactividad es obligatorio`,
    DRAFT: `Guardar como Borrador`,
    DTAC_CASE: `Caso DTAC`,
    DTAC_CASE_NUMBER: `Número de Caso DTAC`,
    DTAC_SOLUTION: `Solución DTAC`,
    DUE_DATE: `Fecha de vencimiento`,
    DUE_WITHIN_3_MONTHS: `Esperado Dentro de los 3 Meses`,
    DUPLICATE_PIN_PLATE: `Placa de PIN duplicada`,
    DUPLICATE_PIN_PLATE_REPORT: `Informe de Placa de PIN Duplicada`, 
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `Solicitud de placa de PIN duplicada actualizada`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `Solicitud de placa de PIN duplicada creada correctamente`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `Solicitud de placa de PIN duplicada ({count})`,
    EDIT: `Editar`,
    EDIT_CUSTOMER: `Editar Cliente`,
    EDIT_LAYOUT: `Editar Diseño de página`,
    EDIT_WITH_PARENTHESES: `(Editar)`,
    EFFECTIVE: `Eficaz`,
    EFFECTIVE_DATE: `Fecha de vigencia`,
    EMAIL: `Correo electrónico`,
    EMISSIONS_PART_SEARCH: `Búsqueda de Pieza de Emisiones`,
    END_DATE: `Fecha de Finalización`,
    END_USE: `Uso Final`,
    END_USE_CODE: `Código de uso final`,
    END_USE_CODE_REQUIRED: `Se requiere código de uso final`,
    ENDS_WITH: `Termina con`,
    ENGLISH: `Inglés`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000: `Ingrese un número entre 0 y 1000`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000: `Ingrese un número entre 0 y 10000`,
    ENTER_A_NUMBER_FROM_1_TO_9999: `Ingrese un número del 1 al 9999`,
    ENTER_A_PART_NUMBER: `Ingrese un número de pieza`,
    ENTER_COMMENTS_BEFORE_ACCEPTING: `Escriba los comentarios antes de aceptar`,
    ENTITY_ID: `ID de entidad`,
    EQUALS: `Igual`,
    ERROR: `ERROR:`,
    ERROR_MESSAGE_TITLE: `Ocurrió un error:`,
    ERROR_MESSAGES: `Mensaje de error`,
    ERROR_MESSAGES_TITLE: `Ocurrieron varios errores:`,
    ERROR_NETWORK_ISSUES: `Un error de red evitó que algunos datos se hayan cargado; inténtelo nuevamente.`,
    ERROR_NO_DATA_TO_EXPORT: `No hay datos para exportar`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION: `Error al recuperar la información del cliente`,
    ERROR_SAP: `No se puede conectar al servidor.  Si el problema continúa, utilice el enlace Contáctenos para obtener asistencia para resolver su problema.`,
    ERROR_SESSION: `Su sesión ha expirado.  Actualice la página para volver a iniciar sesión.`,
    ERROR_UNHANDLED: `El sistema encontró un error inesperado.  Si el problema continúa, utilice la función Ayuda o el enlace Contáctenos para obtener asistencia para resolver su problema.`,
    ERROR_UPLOADING_FILE: `No se añadió el archivo`,
    ESTIMATED_BASIC_DATE: `Fecha Básica Estimada`,
    ESTIMATED_BASIC_DAYS: `Días Básicos Estimados`,
    ESTIMATED_HOURS: `Horas estimadas`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: `Puede que los presupuestos no reflejen el estado de demostración o las horas aún no reportadas.`,
    EXCEEDS_DEMO_THRESHOLD: `Excede límite de demostración`,
    EXCHANGE_RATE: `Tasa de Cambio`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: `Los PIN excluidos no se incluyen en este informe.`,
    EXECUTE: `Ejecutar`,
    EXPAND_ALL: `Expandir Todo`,
    EXPECTED_FIRST_USE: `Primer Uso Esperado`,
    EXPIRATION_DATE: `Fecha de Vencimiento`,
    EXPIRED: `Expirado`,
    EXPIRED_PART_REQUESTS: `Solicitudes de piezas caducadas`,
    EXPIRED_PIPS: `PMP Expirados`,
    EXPIRES: `Expiración`,
    EXPIRING_SOON: `Fecha de expiración próxima`,
    EXPORT: `Exportar`,
    EXTENDED_WARRANTY: `Garantía Extendida`,
    FACTORY: `FÁBRICA`,
    FACTORY_DUPLICATE_PIN_PLATE: `Placa de PIN duplicada`,
    FACTORY_NAME: `Nombre de fábrica`,
    FACTORY_USERS_TAB: `Placa de PIN duplicada ({count})`,
    FAILED: `Se ha averiado`,
    FAILED_AREA: `Área de falla`,
    FAILED_AREA_IS_REQUIRED: `Área de Falla' es requerido.`,
    FAILED_DATE: `Fecha de la Avería`,
    FAILED_DATE_IS_REQUIRED: `El campo Fecha de la Avería es obligatorio.`,
    FAILED_MODE: `Modo de Falla`,
    FAILED_MODE_COMMENTS: `Comentarios del Modo de Falla`,
    FAILED_PART: `Parte Averiada`,
    FAILED_PART_DESCRIPTION: `Descripción de la parte Averiada`,
    FAILED_PART_IS_A_REMAN_PART: `Parte Averiada es una parte ReMan`,
    FAILED_PART_IS_REQUIRED: `Parte averiada es requerido.`,
    FAILED_PART_SERIAL: `Número de Serie de la Parte Averiada`,
    FAILED_PART_SERIAL_IS_REQUIRED: `No. de Serie de la Parte Averiada es requerido.`,
    FAILURE_DATE: `Fecha de la avería`,
    FAILURE_INFORMATION: `Información de la avería`,
    FAILURE_MODE: `Modo de Falla/o`,
    FAILURE_MODE_IS_REQUIRED: `El campo Modo de Avería es requerido.`,
    FAILURE_PART: `Parte averiada`,
    FAILURE_PART_DESCRIPTION: `Descripción de la parte averiada`,
    FAILURE_PART_IS_REQUIRED: `El campo 'Parte Averiada' es requerido.`,
    FAILURE_TO_RETURN_PARTS_WARNING: `El no devolver los artículos solicitados puede resultar en un débito.`,
    FAVORITES: `Favoritos`,
    FILE_NAME: `Nombre del Archivo`,
    FILE_SIZE_IS_TOO_BIG: `El tamaño del archivo es demasiado grande. (Tamaño Máximo 100MB)`,
    FILE_SIZE_IS_TOO_BIG_CSV: `El tamaño del archivo es demasiado grande. (Tamaño Máximo 1MB)`,
    FILE_UPLOAD_MESSAGE: `Descargar archivos aquí o haga clic para agregar archivos. (Tamaño Máximo 100MB)`,
    FILE_UPLOAD_MESSAGE_CSV: `Descargar archivos aquí o haga clic para agregar archivos. (Tamaño Máximo 1MB)`,
    FILE_UPLOAD_MESSAGE_IMAGE: `Descargar imagen aquí o haga clic para agregar imagen. (Tamaño Máximo 100MB)`,
    FILE_UPLOAD_MESSAGE_SINGLE: `Descargue solo un archivo aquí o haga clic para agregar. (Tamaño Máximo 100MB)`,
    FILE_UPLOAD_UNABLE_TO_READ: `El sistema no pudo leer su archivo.  Compárelo con la plantilla e inténtelo de nuevo.`,
    FILES: `Archivos`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `No hay resultados. Pulsar Intro para buscar todas las recomendaciones.`,
    FILTER_PLACEHOLDER: `Filtrar Resultados`,
    FILTER_WITH_ELLIPSIS: `Filtrar…`,
    FILTERED_BY_COLUMN_ID: `Filtrado por {columnId}`,
    FIND_CUSTOMER: `Encontrar Cliente`,
    FINNISH: `Finlandés`,
    FIRST_MAINTENANCE: `PRIMER MANTENIMIENTO`,
    FIRST_NAME: `Nombre`,
    FIRST_NAME_IS_REQUIRED: `El campo 'Nombre' es requerido.`,
    FIRST_SHIP_TO_LOCATION: `Primer Envío a Ubicación`,
    FIRST_USE: `Primer Uso`,
    FISCAL_YEAR: `Año fiscal`,
    FLUID_SAMPLING_REQUIRED: `Muestreo de Fluido Requerido`,
    FORWARDED: `Transferida`,
    FRENCH: `Francés`,
    FROM: `De`,
    FRWRD: `Enviar`,
    FULL_DEBIT: `Débito Completo`,
    GENERAL: `General`,
    GERMAN: `Alemana`,
    GET_MAINTENANCE_PLANS: `Obtener Planes de Mantenimiento`,
    GOODS_INSTALLATION_VAT: `IVA de la Instalación de Productos`,
    GRACE_PERIOD: `Período de Gracias`,
    GREATER_THAN: `Mayor que`,
    GREATER_THAN_OR_EQUALS: `Mayor que o iguales`,
    GROUP_COMPLETE: `Grupo Completo`,
    GST_PERCENTAGE: `GST Porcentaje`,
    H_LIMIT: `Hora límite`,
    HISTORY_TO_DISPLAY: `Mostrar Historial (días)`,
    HOME: `Casa`,
    HOUR_LIMIT: `Hora límite`,
    HOURS: `Horas`,
    HOURS_ON_RENT: `Horas en Alquiler`,
    HSN_SAC_CODE: `HSN/SAC Código`,
    IGST: `IGST`,
    IMPLEMENTS: `Aperos`,
    IN_RANGE: `En el rango`,
    INCENTIVE: `Incentivo`,
    INCENTIVE_PROGRAMS: `Programas de incentivos`,
    INCLUDE_FULLY_COMPLETE: `Incluir PIP completos`,
    INDICATES_REQUIRED_FIELD: `Indica que el campo es requerido`,
    INFO_MESSAGE_TITLE: `Se envió una notificación del sistema:`,
    INFO_MESSAGES: `Mensajes de Información`,
    INFO_MESSAGES_TITLE: `Se enviaron varias notificaciones del sistema:`,
    INFO_REQUEST_STATUS_ERROR: `La información está lista para ser presentada con esta solicitud.`,
    INFORMATION: `Información`,
    INFORMATION_REQUEST: `Solicitud de información`,
    INFORMATION_REQUEST_STATUS: `Estado de solicitud de información`,
    INPUT_PIN: `Introduzca NIP`,
    INSPECTION: `Inspección`,
    INSTALLED_BY: `Instalado por`,
    INSTALLED_BY_IS_REQUIRED: `El campo Instalado Por es obligatorio.`,
    INTERNAL_DEERE_COMMENTS: `Comentarios Internos de Deere`,
    INTERNAL_EQUIPMENT_NOTES: `Notas de equipos internos`,
    INTERVAL_BEGINS: `El Intervalo Comienza`,
    INTERVAL_ENDS: `El Intervalo Finaliza`,
    INTERVAL_TYPE_DESCRIPTION: `Descripción del Tipo de Intervalo`,
    INVOICE_ACCOUNT: `Cuenta de Facturación`,
    INVOICE_DEALER: `Facturar Concesión/Distr.`,
    INVOICE_NUMBER: `Nº de Factura`,
    INVOICE_REQUEST: `Solicitud de Factura`,
    INVOICE_SENT: `Factura Enviada`,
    INVOICE_UPDATED_SUCCESSFULLY: `Factura actualizado con éxito`,
    INVOICED: `Facturado`,
    INVOICED_TO: `Facturado a`,
    IRC_PIN_MESSAGE: `El cliente es un IRC y tiene derecho a un tiempo de traslado y kilometraje gratuitos durante las primeras 500 horas o 12 meses de propiedad de la máquina.`,
    ISSUED: `Emitida`,
    ITALIAN: `Italiano`,
    ITEM: `ít`,
    ITEM_NUMBER: `Número de Artículo`,
    ITEM_NUMBER_IS_REQUIRED: `Número de artículo es requerido.`,
    JDLINK_EXPIRES: `Expira JDLink`,
    JDP_COMMENTS: `Comentarios de JDP`,
    JDP_COMMENTS_IS_REQUIRED: `El campo Comentarios de JDP es requerido.`,
    JDP_CUSTOMER_RESOLUTION: `Resolución del cliente de JDP`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: `El campo Resolución del Cliente de JDP es requerido.`,
    JDP_REASON: `Motivo de JDP`,
    JDP_REASON_IS_REQUIRED: `El campo Motivo de JDP es requerido.`,
    LABOR: `Mano de obra`,
    LABOR_ADDITIVE: `Suplemento de mano de obra`,
    LABOR_ADDITIVE_COMPLETION_DETAIL: `Detalles de la terminación del suplemento de mano de obra`,
    LABOR_ADDITIVE_PIPS: `PIP del suplemento de mano de obra`,
    LABOR_ADDITIVE_TAB: `Suplementario de Mano de Obra ({count})`,
    LABOR_ADJUSTMENT: `Ajuste de la Mano de Obra`,
    LABOR_COMMENTS: `Comentarios de Mano de obra`,
    LABOR_HOURS: `Mano Obra`,
    LABOR_ITEM_DETAILS: `Mano de obra - {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY: `Tarifa de Mano de Obra Aprobada Satisfactoriamente`,
    LABOR_RATE_CHANGE_SUBMITTED: `Modificación del Costo Laboral Enviada`,
    LABOR_RATE_CHANGES_WITH_COUNT: `Cambios de tarifa de mano de obra ({count})`,
    LABOR_RATE_CONFIRM: `La tarifa solicitada es inferior a la tarifa actual.  ¿Está seguro de que desea enviar la solicitud?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Las proporciones en el texto rojo indican un aumento de más del 10% con respecto a la dosis existente`,
    LABOR_RATE_HISTORY: `Historial de la tarifa de mano de obra`,
    LABOR_RATE_REJECTED_SUCCESSFULLY: `Tarifa de Mano de Obra Rechazada Satisfactoriamente`,
    LABOR_RATE_REQUESTS_STATUS: `Estado de solicitudes de tarifas de mano de obra`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `Tarifa de Mano de Obra Devuelta Correctamente`,
    LABOR_RATES: `Tarifa de mano de obra`,
    LABOR_STATS: `Estadísticas de mano de obra`,
    LABOR_TOTAL: `Mano de obra total`,
    LABOR_TYPE: `Tipo de mano de obra`,
    LABOR_VALUE: `Valor de Mano de Obra`,
    LABOR_WITH_COUNT: `Mano de Obra ({count})`,
    LANGUAGE: `Idioma`,
    LAST_LOCATION_FROM: `Última ubicación desde`,
    LAST_NAME: `Apellido`,
    LAST_NAME_IS_REQUIRED: `El campo Apellido es requerido.`,
    LAST_PERSONAL_CONTACT: `Último Contacto Personal`,
    LAST_SEEN: `Visto por última vez`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Visto Por Última Vez En La Cuenta Responsable`,
    LATEST: `Última`,
    LAW_ENFORCEMENT_AGENCY_DETAILS: `Detalles de la Agencia de Cumplimiento de la Ley`,
    LAYOUT_CREATED_SUCCESSFULLY: `Diseño de página creado con éxito`,
    LAYOUT_DELETED_SUCCESSFULLY: `Diseño de página eliminado exitosamente`,
    LAYOUT_NAME: `Nombre del diseño de página`,
    LAYOUT_UPDATED_SUCCESSFULLY: `Diseño de página actualizado con éxito`,
    LEAD_ACCOUNT: `Cuenta Principal`,
    LEAD_DEALER: `Concesionario Principal`,
    LESS_THAN: `menor que`,
    LESS_THAN_OR_EQUALS: `menor o igual que`,
    LICENSE_PLATE_NUMBER: `No. de placa o No. de matrícula`,
    LIFETIME: `De por vida`,
    LINE_ITEMS_EXPORT: `Exportación de artículos de línea`,
    LIST: `Lista`,
    LIST_TOTAL: `Lista Total`,
    LOCATION: `Ubicación`,
    LOCATION_DUE: `Ubicación Prevista`,
    LOCATIONS: `Ubicaciones`,
    LOCATIONS_WITH_COUNT: `Ubicación ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: `La máquina ya está registrada con este cliente.`,
    MACHINE_INFORMATION: `Información de Máquina`,
    MACHINE_MODEL_TYPE: `Modelo/tipo de máquina`,
    MACHINE_MODEL_TYPE_REQUIRED: `Modelo/tipo de máquina requerido`,
    MACHINE_STATUS: `Estatus de Máquina`,
    MACHINE_STATUS_UPDATE: `Actualización de estado de la máquina`,
    MACHINE_STATUS_UPDATE_ACCEPTED: `Actualización de Estado de Máquina Aprobada`,
    MACHINE_STATUS_UPDATE_DOCUMENT: `Documento de Actualización de Estado de Máquina`,
    MACHINE_STATUS_UPDATE_REJECTED: `Actualización de Estado de Máquina Rechazada`,
    MACHINE_STATUS_UPDATES_WITH_COUNT: `Actualizaciones del Estado de la Máquina ({count})`,
    MACHINE_TYPE: `Tipo de máquina`,
    MACHINE_TYPE_IS_REQUIRED: `El campo Tipo de Máquina es requerido.`,
    MACHINE_USE: `Uso de Máquina`,
    MAILING_RECIPIENT: `Destinatario de correo (nombre y apellidos)`,
    MAILING_RECIPIENT_REQUIRED: `Destinatario de correo requerido`,
    MAINTENANCE: `Mantenimiento`,
    MAINTENANCE_PLAN: `Planes de Mantenimiento`,
    MAINTENANCE_PLAN_INFO: `Información sobre el Plan de Mantenimiento`,
    MARK_AS_INPROCESS: `Marcar como en proceso`,
    MARK_AS_REVIEW: `Marcar como revisado`,
    MARKETING_INCENTIVE: `Marketing: Incentivo`,
    MARKETING_JD_PROMISE: `Marketing: Promesa de JD`,
    MARKETING_MAINTENANCE_PLAN: `Marketing: Plan de mantenimiento`,
    MARKETING_MASS_CHANNEL_FOLLOWUP: `Marketing: Seguimiento de Canales en Masa`,
    MARKETING_MASS_CHANNEL_PDI: `Marketing: PDI de Canales en Masa`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP: `Seguimiento de Cliente de Canal en Masa`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: `Recordatorio: Asegúrese de ponerse en contacto con su propio asesor legal a fin de determinar los procedimientos de #No Llamar# adecuados para su estado y a nivel federal antes de implementar el Programa de Seguimiento con Llamadas Posteriores a la Venta.`,
    MASS_CHANNEL_PDI_CLAIM: `PDI de Canal en Masa`,
    MASTER_WARRANTY_TYPE: `Tipo de garantía principal`,
    MATERIAL: `Número de material`,
    MERCHANDISE: `Mercancía`,
    MESSAGE: `Mensaje`,
    MESSAGES: `Mensajes`,
    METHOD_OF_CONTACT: `Método de contacto`,
    METHOD_OF_CONTACT_IS_REQUIRED: `El campo Método de Contacto es requerido.`,
    METRIC: `Criterios de Evaluación`,
    METRICS: `Métricas`,
    MILEAGE_LIMIT: `Límite de Millaje`,
    MOBILE_PHONE: `Teléfono móvil`,
    MODEL: `Modelo`,
    MODEL_NUMBER: `Número de modelo`,
    MODEL_YEAR: `Año de fabricación`,
    MODIFIED: `Modificado`,
    MONTH_TO_DATE: `Mes Actual`,
    MORE: `Más`,
    MULTIPLE: `Múltiple`,
    NAME: `Nombre`,
    NET: `Neto`,
    NET_AMOUNT: `Monto Neto`,
    NET_AMOUNT_PAID: `Monto neto pagado`,
    NET_TOTAL: `Neto Total`,
    NEW: `Nuevo`,
    NEW_ACCOUNT: `Nueva Cuenta`,
    NEW_CLAIM: `Nueva Reclamación`,
    NEW_CLAIM_VALUE: `Nuevo Valor de Reclamación`,
    NEW_CUSTOMER_REQUIRED: `El campo Cliente Nuevo es requerido`,
    NEW_DEALER: `Concesionario/Distr Nuevo`,
    NEW_DEALER_DISTANCE: `Distancia de concesionario nuevo`,
    NEW_DEALER_LOCATION: `Nueva Ubicación del Concesionario`,
    NEW_LABOR_RATE: `Nueva Tarifa de Mano de Obra`,
    NEW_REQUEST_ENTER_RATES: `Solicitud nueva - Introducir dosis`,
    NEW_STATUS: `Nuevo estatus`,
    NEW_TRANSFER: `Nueva Transferencia`,
    NEW_TRANSFER_CREATED: `Nueva Transferencia Creada`,
    NEW_VALUE: `Valor Nuevo`,
    NO: `No`,
    NO_ACTIVE_WARRANTY: `Sin garantía activa`,
    NO_AFFECTED_PINS: `No hay NIPs afectados bajo responsabilidad de su concesionario.`,
    NO_AUTHORITY_TO_ACCESS: `Usted no tiene autoridad para acceder al JDWS. Los usuarios del concesionario deben consultar al Administrador de perfiles (DPA) para verificar la autoridad y los usuarios de Deere se comunican con el servicio de asistencia con una copia de este error aquí`,
    NO_CLAIMS: `No hay reclamaciones.`,
    NO_CUSTOMER_ASSOCIATED: `No hay Clientes Asociados`,
    NO_CUSTOMER_SELECTED: `No se seleccionó Ningún Cliente`,
    NO_DEALER_INVOICES: `No hay Facturas del Concesionario.`,
    NO_DEALERS_MAPPED: `No hay concecionarios asignados a su ID de usuario. Por favor contacte a su administrador de sistemas.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE:`No (Si la respuesta es no, debe proporcionarse una imagen como evidencia)`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: `Información no disponible para este producto`,
    NO_LABOR_COVERAGE: `Sin cobertura de mano de obra`,
    NO_LOWERCASE: `No`,
    NO_MATCHING_DEALERS: `Ningún concesionario coincide con el texto del filtro.`,
    NO_OPEN_PART_REQUESTS: `No hay solicitudes de partes abiertas`,
    NO_OPEN_PIPS: `No hay PIP abiertos`,
    NO_PARTS_RETURNED: `Partes no devueltas`,
    NO_PIP_PRODUCTS: `No hay productos PIP.`,
    NO_PRODUCT_FOUND: `No se encontró producto.`,
    NO_REQUIRED_ITEMS: `No hay elementos requeridos.`,
    NO_RESULTS: `Sin resultados`,
    NO_RESULTS_FOUND: `No se Encontraron Resultados.`,
    NO_ROWS_TO_SHOW: `No hay lineas para monstrar.`,
    NO_SPECIAL_INSTRUCTIONS: `No hay instrucciones especiales.`,
    NO_TRAVEL: `No se reembolsan costos de viáticos`,
    NON_RECOVERABLE_TAXES: `Impuestos No Recuperables`,
    NON_TRACKED_PINS_HELP_TEXT: `Algunos productos no aparecen en la Garantía hasta después del registro. La búsqueda coincide con varios de estos productos.`,
    NON_TRAVEL: `Sin Viaje`,
    NONE: `Ningún`,
    NORMAL: `NORMAL`,
    NOT_EQUAL: `No es igual`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Notificación agregada correctamente`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Notificación eliminada correctamente`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: `Secuencia de notificación actualizada correctamente`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Notificación exitosamente Actualizado`,
    NOTIFICATIONS: `Notificaciones`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES: `Cantidad de Instancias de Diagnóstico`,
    NUMBER_OF_OPEN_PIPS: `{number} Pips abiertos`,
    NUMBER_OF_REPAIR_OCCURRENCES: `Cantidad de Instancias de Reparación`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES: `Cantidad de Instancias de Reemplazo`,
    OLD_LABOR_RATE: `Tarifa de Mano de Obra Anterior`,
    ON_SHELF: `En almacén`,
    ON_SHELF_COST: `Costo de Almacenaje`,
    ONE_ITEM_MUST_BE_SELECTED: `Se debe seleccionar un elemento.`,
    OPEN: `Abiertas`,
    OPEN_PART_REQUESTS: `Solicitudes de Partes Abiertas`,
    OPEN_PART_REQUESTS_WITH_COUNT: `Solicitudes de Partes Abiertas ({count})`,
    OPEN_PIP_COUNT: `Recuento de PIP abierto`,
    OPEN_PIP_PROGRAMS: `Registro de PMP`,
    OPEN_PIPS: `PIPs abiertos/ vigentes`,
    OPEN_PIPS_REPORT: `Informe de Programa de Mejoras sin Terminar`,
    OPEN_PIPS_TAB: `PIPs abiertos/ vigentes ({count})`,
    OPEN_PIPS_Y_N: `PIP abiertos (S/N)`,
    OPERATORS_COMPLAINT: `¿Cuál fue la reclamación del operador?`,
    OPERATORS_COMPLAINT_IS_REQUIRED: `El campo Reclamación del Operador es requerido.`,
    OPERATORS_MANUAL_NUMBER: `Nº de Manual de Operador`,
    OPTION_CODE: `Código de Opción`,
    OPTION_CODE_CREATED_SUCCESSFULLY: `Código de Opción creado satisfactoriamente`,
    OPTION_CODE_DELETED_SUCCESSFULLY: `Código de Opción borrado satisfactoriamente`,
    OPTION_CODES: `Código de Opciones`,
    OR: `o`,
    ORIGINAL_CLAIM_VALUE: `Valor de reclamación original`,
    ORIGINAL_SUBMISSION_DATE: `Fecha Original de Envío`,
    ORIGINALLY_SUBMITTED: `Originalmente enviado/sometido`,
    OTHER: `Otro`,
    OTHER_AMOUNT_OF_USE: `Otras horas de uso`,
    OTHER_AMOUNT_OF_USE_REQUIRED: `El campo 'otras horas de uso' es requerido `,
    OTHER_CREDIT: `Otro crédito`,
    OTHER_CREDIT_1: `Otro crédito 1`,
    OTHER_CREDIT_2: `Otro crédito 2`,
    OTHER_CREDIT_3: `Otro crédito 3`,
    OTHER_CREDIT_ADJUSTMENT: `Otro ajuste de crédito`,
    OTHER_CREDIT_ITEM_DETAILS: `Otro crédito - {description} ({quantity} {unit})`,
    OTHER_CREDIT_TOTAL: `Total de Otros Créditos`,
    OTHER_CREDITS: `Otros Créditos`,
    OTHER_CREDITS_WITH_COUNT: `Otros Créditos ({count})`,
    OTHER_INSTRUCTIONS: `Otras instrucciones`,
    OUTPUT_PIN: `Resultado de No. de serie o NIP`,
    OVERDUE: `Vencidas`,
    OVERRIDE_ACCOUNT: `Anular cuenta`,
    OVERRIDE_EFFECTIVE_DATE: `Fecha de vigencia anulada`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Anular cuenta sugerida`,
    OWNERSHIP_STATUS: `Estado del Propietario`,
    OWNERSHIP_STATUS_IS_REQUIRED: `El campo 'Estado de Propietario' es requerido.`,
    PART: `Parte`,
    PART_1: `Parte 1`,
    PART_2: `Parte 2`,
    PART_3: `Parte 3`,
    PART_4: `Parte 4`,
    PART_5: `Parte 5`,
    PART_6: `Parte 6`,
    PART_7: `Parte 7`,
    PART_8: `Parte 8`,
    PART_9: `Parte 9`,
    PART_10: `Parte 10`,
    PART_AMONT_OF_USE: `Cantidad de uso de la parte`,
    PART_FAMILY: `Familia de la parte`,
    PART_ITEM_DETAILS: `Partes - {quantity} {description} Número de parte {partNumber}`,
    PART_NUMBER: `Número de parte`,
    PART_REQUEST: `Solicitud de Pieza`,
    PART_REQUEST_NUMBER: `Número de solicitud de parte {rgaNumber}`,
    PART_REQUEST_STATUS: `Estado de la Solicitud de Partes`,
    PART_REQUESTS: `Solicitudes de partes`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: `Ingrese un Número de Reclamo; mínimo de 4 caracteres`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: `La búsqueda de reclamaciones debe ser de al menos 4 caracteres.`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: `La búsqueda de Número de Caso DTAC debe ser el Número de Caso DTAC completo; al menos 4 caracteres.`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: `Ingrese un Número de Caso DTAC completo.`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: `El Número de Parte debe tener al menos 4 caracteres.`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: `Ingrese Número de Parte; mínimo 4 caracteres.`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: `La búsqueda de Número de Solicitud de Parte debe ser al menos 4 caracteres.`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: `Ingrese Número de Solicitud de Parte; mínimo  4 caracteres.`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR: `La Búsqueda de PIN/NIP debe ser de al menos 4 caracteres.`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: `Ingrese un NIP; mínimo de 4 caracteres.`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: `La búsqueda de Orden de Trabajo debe ser una Orden de Trabajo completa; al menos 2 caracteres.`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: `Ingrese una Orden de Trabajo completa.`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY: `Solicitud de Parte actualizada correctamente`,
    PART_RETURN: `Devolución de Parte`,
    PART_RETURNS: `Devolución de Partes`,
    PART_SERIAL_NUMBER: `Número de Serie de la Parte`,
    PART_SERIAL_NUMBER_IS_REQUIRED: `El campo Número de Serie de la Parte es requerido.`,
    PART_TOTAL: `Total de partes`,
    PART_TYPE: `Tipo de parte`,
    PART_USE: `Uso de la parte`,
    PART_VALUE: `Valor de la parte`,
    PARTIAL_DEBIT: `Débito Parcial`,
    PARTICIPANT: `Participante`,
    PARTS: `Partes`,
    PARTS_ADDITIVE: `Suplemento de partes`,
    PARTS_ADJUSTMENTS:`Ajuste de piezas`,
    PARTS_COVERAGE_SEARCH: `Búsqueda de cobertura de partes`,
    PARTS_TEMPLATE: `Plantilla de piezas`,
    PARTS_USE: `Uso de las partes`,
    PARTS_USE_IS_REQUIRED: `El campo 'Uso de la parte' es obligatorio.`,
    PARTS_WITH_COUNT: `Partes ({count})`,
    PARTS_WITH_PARENTHESES: `Parte(s)`,
    PAST_DUE: `Vencido(a)`,
    PAYER_ACCOUNT: `Cuenta del Pagador`,
    PC_LIMIT:`Límite de paca`,
    PERCENT_COMPLETE: `Porcentaje completo`,
    PERCENTAGE: `Porcentaje`,
    PERCENTAGE_DEBIT: `Débito porcentual`,
    PERCENTAGE_SYMBOL: `{percentage}%`,
    PERCENTAGE_TO_DEBIT: `Porcentaje para Débito`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT:`Para las máquinas que se encuentran permanentemente fuera de servicio, incluya una imagen de la máquina para verificar que esta no se puede reconstruir, ni reparar ni utilizar en el futuro. Las máquinas que se encuentran permanentemente fuera de servicio no califican para ninguna clase de Programa de Mejoramiento de Productos (PIP).`,
    PERSON_RESPONSIBLE: `Persona responsable`,
    PHONE: `Teléfono`,
    PHONE_REQUIRED: `Teléfono requerido`,
    PICTURE: `Imagen`,
    PICTURE_REQUEST: `Solicitud de imagen`,
    PICTURE_REQUEST_STATUS: `Estado de solicitud de imagen`,
    PICTURE_REQUEST_STATUS_ERROR: `Los archivos adjuntos están listos para ser enviados con esta solicitud.`,
    PIN: `Números de serie`,
    PIN_CREATED_SUCCESSFULLY: `NIP/Número de serie creado correctamente`,
    PIN_CROSS_REFERENCE: `Referencia cruzada de Número de Serie`,
    PIN_INVALID: `NIP/Número de serie no válido`,
    PIN_IS_REQUIRED: `El NIP/Número de serie es requerido`,
    PIN_REQUIRED: `El NIP/Número de serie es requerido`,
    PIN_SEARCH: `Búsqueda de pasadores`,
    PIN_SEARCH_INFORMATION: `Información de búsqueda de pasadores`,
    PIN_TRANSFER_INFORMATION: `Información de transferencia de pasadores`,
    PINS: `PIN`,
    PINS_NOT_REGISTERED: `Nº de serie no esta registrado`,
    PIP: `Programa`,
    PIP_CODE: `Código de Programa de Mejora del Producto`,
    PIP_CODE_CREATED_SUCCESSFULLY: `Solicitud de código de programa de mejora del producto (PIP) creado correctamente`,
    PIP_CODE_REQUEST: `Solicitud de código PMP`,
    PIP_CODE_REQUEST_APPROVED: `Solicitud de Código PMP Aprobada`,
    PIP_CODE_REQUEST_REJECTED: `Solicitud de Código PMP Rechazada`,
    PIP_CODE_REQUESTS_WITH_COUNT: `Solicitudes de Código PMP ({count})`,
    PIP_COMPLETION_STATUS: `Estatus de Finalización de PMP`,
    PIP_DETAILS: `Detalles del PMP`,
    PIP_HISTORY: `Historial de PMP`,
    PIP_ID: `N.º de PMP`,
    PIP_NUMBER: `Nº de Programa de Mejora del Producto`,
    PIP_PROGRAM: `Programa de Mejora del Producto (PMP)`,
    PIP_PROGRAM_IS_REQUIRED: `El campo Programa de Mejora del Producto (PIP) es obligatorio.`,
    PIP_PROGRAMS: `Programas PMP`,
    PIP_SEARCH: `Buscar PMP`,
    PIP_STATUS: `Estado de PMP`,
    PIP_TYPE: `Tipo de PMP`,
    PIP_TYPES: `Tipos de PMP`,
    PIPS: `PMP- Programa de Mejora del Producto`,
    PIPS_UNPAID_LABOR_ADDITIVE: `Prima por mano de obra de PMP`,
    PLAN_DESCRIPTION: `Descripción del Plan`,
    PLAN_END_DATE: `Fecha de Finalización del Plan`,
    PLAN_ENDS: `Plan finaliza`,
    PLAN_NAME: `Nombre del Plan`,
    PLAN_NAME_IS_REQUIRED: `El campo Nombre del Plan es requerido.`,
    PLAN_NAMES: `Nombres del Plan`,
    PLAN_START_DATE: `Fecha de Inicio del Plan`,
    PLAN_STARTS: `Inicia el plan`,
    PLANNED_BY: `Planificado por`,
    PLANT: `Planta`,
    PLATE_REQUEST_INFORMATION: `Información de solicitud de placa`,
    PLEASE_SELECT_A_LEAD_ACCOUNT: `Seleccione una cuenta principal`,
    PLEASE_SELECT_CLAIM_TYPE: `Por favor seleccione el tipo de reclamo`,
    POLISH: `Polaco`,
    PORTUGUESE: `Portugués`,
    POSTAGE_DELIVERY_DATE: `Fecha de entrega de franqueo`,
    POSTAL_CODE: `Código postal`,
    POSTAL_CODE_REQUIRED: `Código postal requerido`,
    POSTAL_TRACKING_NUMBER: `Número de rastreo postal`,
    POTENTIAL_RESPONSIBLE_DEALER: `Posible concesionario responsable`,
    PRE_DELIVERY_INSPECTION: `Inspección de pre entrega`,
    PREFERRED_THEME: `Tema Preferido`,
    PREPARE_AUDIT: `Preparar la Auditoría`,
    PREPARED: `Preparado`,
    PREPARING_AUDIT_FOR_WITH_DEALER: `Preparando la auditoría para {dealer}`,
    PREVIOUS_AMOUNT_OF_USE: `Cantidad anterior de horas utilizadas`,
    PREVIOUS_INVOICE_NUMBER: `Número de Factura Anterior`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: `El número de la factura anterior es necesario.`,
    PREVIOUS_MONTH: `Mes Anterior`,
    PRICE: `Precio`,
    PRICING_SUMMARY: `Resumen de Precios`,
    PRIMARY_ACTION: `Acción Principal`,
    PRIMARY_LANGUAGE: `Idioma Principal`,
    PRINT: `Imprimir`,
    PRINT_CLAIM: `Imprimir Reclamación`,
    PRINT_REGISTRATION_FORM: `Imprimir el formulario de registro`,
    PRINT_REGISTRATION_FORM_MESSAGE: `La máquina está registrada al propietario anterior. ¿Desea imprimir el formulario de registro?`,
    PRINT_TO_PDF: `Imprentar PDF`,
    PRIORITY: `Prioridad`,
    PRNT_CLM: `Mostrar Reclamación`,
    PROCESS_DATE: `Fecha de Proceso`,
    PROCESSED: `Procesado`,
    PROCESSED_PART_REQUESTS: `Solicitudes de partes procesadas`,
    PROCESSING_STATUS: `Estado de procesamiento`,
    PROCESSING_STATUS_DESCRIPTION: `La descripción del estado de procesamiento`,
    PRODUCT_DETAILS: `Detalles del producto`,
    PRODUCT_HIERARCHY: `Jerarquía de productos`,
    PRODUCT_INFORMATION: `Informe de producto`,
    PRODUCT_REGISTERED: `Equipo Registrado`,
    PRODUCT_REGISTRATION: `Registración del producto`,
    PRODUCT_REGISTRATION_PENDED: `El registro esta pendiente`,
    PRODUCT_TRACKING: `Rastro de Producto`,
    PRODUCTS: `Productos`,
    PRODUCTS_BY_CUSTOMER: `Productos por cliente`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: `Los PIN históricos pueden faltar en los resultados de búsqueda debido a un problema temporal de conectividad del sistema.`,
    PRODUCTS_WITH_COUNT: `Productos ({count})`,
    PROGRAM: `Programa`,
    PROGRAM_DESCRIPTION: `Descripción del programa`,
    PROGRAM_IS_REQUIRED: `El nombre del programa es obligatorio.`,
    PROGRAM_NAME: `El nombre del programa`,
    PROGRAM_NAME_IS_REQUIRED: `El nombre del programa es obligatorio.`,
    PROGRAM_NUMBER: `Número de programa`,
    PRT: `Rastro de Producto`,
    PRTS: `PRT`,
    PURCHASE_INFO: `Información de Compra`,
    PURCHASE_ORDER: `Orden de Compra`,
    PURCHASE_ORDER_IS_REQUIRED: `El orden de compra es necesario.`,
    PURCHASER_TYPE: `Tipo de compradora`,
    PURCHASER_TYPE_REQUIRED: `El tipo de comprador es necesario`,
    PUSH_XML: `Volver a enviar XML`,
    QTY: `Cantidad`,
    QUALIFY_FOR_EMISSIONS: `Cumple los Requisitos de Emisiones`,
    QUANTITY: `Cantidad`,
    QUANTITY_1: `Cantidad 1`,
    QUANTITY_2: `Cantidad 2`,
    QUANTITY_3: `Cantidad 3`,
    QUANTITY_4: `Cantidad 4`,
    QUANTITY_5: `Cantidad 5`,
    QUANTITY_6: `Cantidad 6`,
    QUANTITY_7: `Cantidad 7`,
    QUANTITY_8: `Cantidad 8`,
    QUANTITY_9: `Cantidad 9`,
    QUANTITY_10: `Cantidad 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS: `La consulta debe contener al menos 3 caracteres`,
    QUEST_DESC: `Descripción Cuestionable`,
    QUESTIONABLE_PART: `Pieza cuestionable`,
    QUEUED: `En cola`,
    READING_DATE: `Fecha de lectura`,
    REASON: `Razón`,
    REASON_EVENT_NUMBER: `Número de evento de razón`,
    REASON_FOR_CHANGE: `Razón por cambio`,
    REASON_FOR_DEBIT: `Razón de débito`,
    REASON_FOR_MISSING_PLATE: `Razón de la placa faltante`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Razón para la placa faltante requerida`,
    REASON_FOR_OVERRIDE: `Razón de anulación`,
    REASON_FOR_REFUSAL: `Razón de rechazo`,
    REASON_FOR_RETURN: `Razón de regreso`,
    REASON_FOR_RETURN_IS_REQUIRED: `el razón por el regreso es necesario.`,
    REASON_FOR_TRANSFER: `Razón de la transferencia`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: `El razon por la transferencia debe incluir caracteres alfanuméricos`,
    REASON_FOR_TRANSFER_REJECTION: `Motivo del rechazo de la transferencia`,
    RECIPIENT_DEALER_OR_TCSM: `Destinatario(concesionario o TCSM)`,
    RECIPIENT_MAILING: `Destinatario de correo`,
    RECOMMENDATION: `Recomendación`,
    RECOMMENDATION_DATE: `Fecha de recomendación`,
    RECOMMENDED_ACCOUNT: `Cuenta recomendada`,
    RECONCILE: `Conciliación`,
    RECONCILE_CLAIM: `Conciliar reclamo`,
    RECONCILED: `CONCILIADO`,
    RECORD_AUDIT: `Registrar la auditoría`,
    RECORD_AUDIT_FOR: `Registrar la auditoría para el distribuidor`,
    RECORDS_FOUND: `{count, plural, one {Se encontró {countToDisplay} registro} other {Se encontraron {countToDisplay} registros}}`,
    RECOVERABLE_TAXES: `Impuestos recuperables`,
    RECOVERED: `Recuperado`,
    RECOVERED_WITH_MISSED_ADDITIVES: `Recuperado Con Aditivos Perdidos`,
    RECOVERED_WITHOUT_ADDITIVES: `Recuperado Sin Aditivos`,
    RECOVERY: `Recuperación`,
    RED_MUST_BE_LESS_THAN_YELLOW: `El valor del indicador rojo debe ser menos que el valor del indicador amarillo`,
    REFERENCE_1: `Referencia 1`,
    REFERENCE_2: `Referencia 2`,
    REFERENCE_INFORMATION: `Información de Referencia`,
    REFERENCE_NUMBER1: `Nº de Referencia1`,
    REFERENCE_NUMBER2: `Nº de Referencia2`,
    REGION: `Región`,
    REGISTER: `Registrar`,
    REGISTER_A_PRODUCT_BY_PIN: `Registrar un producto por PIN`,
    REGISTER_A_PRODUCT_TO_ADD: `Registrar el producto para añadir al sistema de garantía`,
    REGISTER_ANOTHER_PRODUCT: `Registrar Otro Producto`,
    REGISTER_PRODUCT: `Registro de Producto`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER: `Registrar el producto y registrar otro`,
    REGISTERED: `Registrado`,
    REGISTRATION: `Registro`,
    REGISTRATION_DATE: `Fecha de Registro`,
    REGISTRATION_DATES: `Fechas de Registro`,
    REGISTRATION_FORM: `Formulario de Registro`,
    REGISTRATION_HISTORY: `Historial de Registro`,
    REGISTRATION_NOT_ALLOWED: `No se permite registrar este producto`,
    REGISTRATION_REVIEW: `Revisión de Registro`,
    REGISTRATION_REVIEW_TAB: `Revisión de Registro ({count})`,
    REGISTRATION_STATUS: `Estatus de Registro`,
    REGISTRATION_STATUS_CANNOT_BE_NEW: `El Estado del Registro no puede ser Nuevo`,
    REGISTRATION_STATUS_REQUIRED: `El estatus de registro es necesario`,
    REGISTRATION_SUCCESS: `Registro exitoso`,
    REGISTRATION_TYPE: `Tipo de Registro`,
    REGISTRATION_TYPE_CANNOT_BE_NEW: `El Tipo de Registro no puede ser Nuevo`,
    REGISTRATION_TYPE_REQUIRED: `El tipo de registro es necesario`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Registro actualizado con éxito`,
    REGISTRATIONS_REVIEW: `Revisión de Registros`,
    REIMBURSED: `Reembolsado`,
    REIMBURSED_AMOUNT: `Cantidad Reembolsada`,
    REIMBURSED_PERCENTAGE: `Porcentaje Reembolsado`,
    REIMBURSED_PERCENTAGE_INDICATOR: `Indicador de Porcentaje Reembolsado`,
    REIMBURSEMENT_DETAILS: `Detalles del Reembolso`,
    REIMBURSEMENT_PERCENTAGE: `Porcentaje de Reembolso`,
    REIMBURSEMENT_SUMMARY: `Resumen de reembolsos`,
    REJECT: `Rechazar`,
    REJECT_LABOR_RATE: `Rechazar la tasa de trabajo`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM: `Rechazar el reclamo de la prestación especial`,
    REJECTED: `Rechazado`,
    REJECTED_APPEAL: `Solicitud Rechazada`,
    RELATIONSHIP: `Relación`,
    RELATIONSHIP_IS_REQUIRED: `La relación es necesaria.`,
    REMOVE_FILTER: `Eliminar Filtro`,
    REMOVE_FROM_AUDIT: `Quitar de Auditoría`,
    REMOVE_LAYOUT: `Eliminar diseño de página`,
    RENTAL_PINS: `PIN de alquiler`,
    REPAIR_DATE: `Fecha de Reparo`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: `La fecha de reparación no puede ser anterior a la fecha de falla`,
    REPAIR_NUMBER: `Número de reparación`,
    REPAIR_NUMBER_IS_REQUIRED: `El número de reparación es necesario.`,
    REPAIR_REPLACE_INDICATOR: `Indicador de Reparación/Reemplazo`,
    REPAIRED: `Reparación`,
    REPAIRED_DATE: `Fecha de Reparación`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: `La fecha de reparación no puede ser anterior a la fecha de la falla.`,
    REPAIRED_DATE_IS_REQUIRED: `La fecha de la reparación es necesaria.`,
    REPORT_DATE: `Fecha del Informe`,
    REPORT_NUMBER: `Número de Informe`,
    REPORTS: `Reportes`,
    REQ_ADDL: `Ajuste Nota de Crédito`,
    REQUEST: `Solicitud`,
    REQUEST_DATE: `Fecha de Solicitud`,
    REQUEST_DETAILS: `Detalles de la solicitud`,
    REQUEST_DUPLICATE_PIN_PLATE: `Solicitud de placa de PIN duplicada`,
    REQUEST_FORM: `Formularios de Solicitud`,
    REQUEST_PIP_CODE: `Solicitar Código de PIP`,
    REQUEST_STATUS: `Solicitude estado`,
    REQUEST_SUBMITTED: `Solicitud Enviada`,
    REQUEST_TYPE: `Typo de solicitud`,
    REQUEST_UPDATED_SUCCESSFULLY: `Solicitud actualizada exitosa`,
    REQUEST_WARRANTY_CLAIM_DEBIT: `Solicitar debito del reclamo de garantía`,
    REQUESTED: `Solicitado`,
    REQUESTED_BY: `Solicitado Por`,
    REQUESTED_DATE: `Fecha de Solicitud`,
    REQUESTED_DATES: `Fechas Solicitadas`,
    REQUESTED_DIAGNOSTIC_AMOUNT: `Monto de diagnóstico solicitado`,
    REQUESTED_DIAGNOSTIC_HOURS: `Horas de diagnóstico solicitado`,
    REQUESTED_LABOR_AMOUNT: `Cantidad de Mano de Obra Solicitada`,
    REQUESTED_LABOR_HOURS: `Horas de Mano de Obra Solicitadas`,
    REQUESTED_OTHER_CREDITS: `Otros Créditos Solicitados`,
    REQUESTED_PARTS: `Piezas Solicitadas`,
    REQUESTED_REPAIR_AMOUNT: `Monto de reparación solicitado`,
    REQUESTED_REPAIR_HOURS: `Horas de reparación solicitado`,
    REQUESTED_TRAVEL_TOTAL: `Total de Desplazamiento Solicitado`,
    REQUESTER_TCSM: `Solicitante (TCSM)`,
    REQUESTER_TCSM_REQUIRED: `Solicitante (TCSM) requerido`,
    REQUIRED: `*Necesario/a`,
    REQUIRED_CRITERIA: `Criterios Requeridos`,
    REQUIRED_ITEMS: `Artículos requeridos`,
    RESEND_XML: `Volver a enviar XML`,
    RESET: `Reajustar`,
    RESPONDENT_INFORMATION: `Información del Encuestado`,
    RESPONSIBILITY_OF: `Responsabilidad de`,
    RESPONSIBLE_ACCOUNT: `Cuenta Responsable`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED: `La cuenta responsible es necesaria`,
    RESPONSIBLE_DEALER: `Distribuidor/Concesión Responsable`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `Mostrando los primeros 100 resultados. Descargar para obtener los resultados completos`,
    RET: `Devolución`,
    RETAIL_INSTALL: `Venta/Instalación`,
    RETAIL_INSTALL_DATE: `Fecha de Instalación`,
    RETAIL_INSTALL_IS_REQUIRED: `El campo Venta/Instalación es obligatorio.`,
    RETAILER_NAME: `Nombre del comercio de auto servicio`,
    RETAILER_NAME_IS_REQUIRED: `El nombre del minorista es necesario.`,
    RETRY: `volver a intentar`,
    RETURN: `Devolución`,
    RETURN_LABOR_RATE: `Tarifa de Mano de Obra de Retorno`,
    RETURN_REQUESTS: `Solicitud de devolución`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM: `Devolver el reclamo de la prestación especial`,
    RETURN_STATUS: `Estatus de devolución`,
    RETURNED: `Devuelta`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: `La fecha de devolución no puede ser anterior a la fecha de entrega.`,
    RETURNED_DATE_IS_REQUIRED: `La fecha de devolución es necesaria.`,
    RETURNED_MACHINE_STATUS_UPDATE: `Actualización de estado de la máquina devuelta`,
    REVIEW_DEALER_RECOMMENDATIONS: `¿Está seguro de que desea marcar los PIN para revisión?`,
    REVISE: `Revisar`,
    REVISED: `Revisada`,
    ROLLING_12_CREDIT_AMOUNT: `12 meses de monto de credito`,
    ROLLING_12_MONTHS: `12 Meses Continuos`,
    RUN_REPORT: `Ejecutar Informe`,
    RUSSIAN: `Ruso`,
    SAP_DOWN_WARNING: `La funcionalidad del sistema de garantía está menoscabada. Estamos trabajando para corregir esto lo antes posible. Actualizar el navegador para comprobar la disponibilidad del sistema.`,
    SAVE: `Guardar`,
    SAVE_AS_DRAFT: `Guardar como Borrador`,
    SAVE_AS_NEW_LAYOUT: `Guardar como nuevo diseño`,
    SAVE_AUDIT: `Guardar Auditoría`,
    SAVE_CHANGES: `Guardar Cambios`,
    SAVE_TO_VALIDATE: `Guardar para validar`,
    SAVE_VALD: `Guardar y Validar`,
    SAVE_VALIDATE: `Guardar y Validar`,
    SEARCH: `Buscar`,
    SEARCH_BOX_PLACEHOLDER: `Rellenar PIN, N.º de Serie, N.º de Reclamo, Caso de DTAC o Nombre del Cliente`,
    SEARCH_BY_CLAIM_TYPE: `Rellenar tipo de reclamo completo.`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: `La búsqueda de reclamo debe ser por el tipo de reclamo completo, de 4 a 9 caracteres.`,
    SEARCH_BY_FAILURE_PART_NUMBER: `rellenar número completo de la parte de fallo.`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: `La búsqueda de reclamo debe ser por el número completo de la parte de fallo,mínimo de 4 caracteres.`,
    SEARCH_BY_WORK_ORDER: `Rellenar orden de trabajo, mínimo de 2 caracteres.`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: `La búsqueda de orden de trabajo debe ser de mínimo de 2 caracteres.`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: `Rellenar número de reclamo completo`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: `La búsqueda de reclamo debe ser por el número de reclamo, de 4 a 9 caracteres.`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: `Rellenar número de serie completo del componente`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: `La búsqueda de componentes debe ser por el número de serie completo, al menos 1 carácter`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: `Introducir PIN`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: `Rellenar número de modelo completo`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: `La búsqueda de modelo debe ser por el número de modelo completo, de 3 a 12 caracteres`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: `Rellenar PIN, mínimo de 6 caracteres`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: `La búsqueda de PIN debe ser de 6 a 17 caracteres.`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: `Rellenar el numero de PIP, mínimo de 4 caracteres`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: `La búsqueda de PIP debe ser de 4 a 12 caracteres`,
    SEARCH_RESULTS_TAB: `Resultados de la Búsqueda ({count})`,
    SECOND_SHIP_TO_LOCATION: `Segundo Envío a Ubicación`,
    SELECT: `Seleccionar`,
    SELECT_A_RANGE: `Seleccionar un gama`,
    SELECT_ALL: `Seleccionar Todo`,
    SELECT_AUTO_SUBMIT: `Seleccionar Enviar Automáticamente`,
    SELECT_BRANCH: `Seleccionar un sucursal`,
    SELECT_CLAIM_TYPE: `Seleccionar tipo de reclamo`,
    SELECT_CLAIMS: `Seleccionar Reclamos`,
    SELECT_CLAIMS_WITHIN_DATE_RANGE: `Seleccionar Reclamos Dentro de Rango de Fechas`,
    SELECT_COLUMNS: `Seleccionar columnas`,
    SELECT_COUNTRY: `Seleccionar país`,
    SELECT_CSV_SEPARATOR: `Seleccionar separador CSV`,
    SELECT_DATE_FORMAT: `Seleccionar Formato de Fecha`,
    SELECT_DEALERS_AND_STATUS: `Seleccionar distribuidores y estado`,
    SELECT_DECIMAL_FORMAT: `Seleccionar Formato Decimal`,
    SELECT_DISPLAY_FORMAT: `Seleccionar formato de visualización`,
    SELECT_FACTORY: `Seleccionar Fábrica`,
    SELECT_LANGUAGE: `Seleccionar Idioma`,
    SELECT_LAYOUT: `Seleccionar Diseño de página`,
    SELECT_NEW_CLAIMS: `Seleccionar Nuevos Reclamos`,
    SELECT_PIP_CODE: `Seleccionar código PIP`,
    SELECT_PLAN_NAMES: `Seleccionar Nombres del Plan`,
    SELECT_SERVICE_INTERVAL_TYPES: `Seleccionar tipos de intervalo de servicio`,
    SELECT_SORT_BY: `Seleccionar Ordenar Por`,
    SELECT_SORT_DIRECTION: `Seleccionar Dirección de Orden`,
    SELECT_STATE: `Seleccionar Estado`,
    SELECT_STATUS: `Seleccionar estatus`,
    SELECT_TERRITORY: `Seleccionar territorio`,
    SELECT_THEME: `Seleccionar Tema`,
    SELECT_TIME_ZONE: `Seleccionar Zona Horaria`,
    SELECT_VALUES_TO_APPROVE: `Seleccionar Valores para Aprobar`,
    SELECTED_COLUMNS: `Columnas Seleccionadas`,
    SELECTED_FOR_AUDIT: `Seleccionado para Auditoría`,
    SELECTED_FOR_AUDIT_VSR: `Consultar la solución DTAC 221475 para la documentación de auditoría requerida y los accesorios necesarios para esta reclamación`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: `Selección de varios tipos de cuentas y tipos de garantía afecta el rendimiento`,
    SEND: `Enviar`,
    SERIAL_NUMBER: `Número de Serie`,
    SERIAL_NUMBER_INVOICE_NUMBER: `Número de Serie / Número de Factura`,
    SERVER_TOOK_TOO_LONG_TO_REPLY: `El servidor tardó demasiado en responder y la solicitud se canceló. Intente una solicitud más específica o vuelva a intentarlo más tarde.`,
    SERVICE_DATE_IS_REQUIRED: `La fecha de servicio es necesaria.`,
    SERVICE_INTERVAL: `El intervalo de servicio es necesario`,
    SERVICE_INTERVAL_BEGIN_DATE: `Fecha de Inicio del Intervalo de Servicio`,
    SERVICE_INTERVAL_END_DATE: `Fecha de Finalización del Intervalo de Servicio`,
    SERVICE_INTERVAL_IS_REQUIRED: `El campo Intervalo de Mantenimiento es obligatorio.`,
    SERVICE_INTERVAL_NUMBER: `Número de Intervalo de Servicio`,
    SERVICE_INTERVAL_STATUS: `Estatus de Intervalo de Servicio`,
    SERVICE_INTERVAL_TYPE: `Tipo de Intervalo de Servicio`,
    SERVICE_INTERVAL_TYPES: `Tipos de Intervalos de Servicio`,
    SERVICE_PART: `Parte de servicio`,
    SERVICE_UNAVAILABLE: `Servicio No Disponible`,
    SERVICED: `Mantenimiento`,
    SERVICED_DATE_IS_REQUIRED: `Se requiere fecha de servicio.`,
    SERVICED_IS_REQUIRED: `Se requiere fecha de servicio.`,
    SET_AS_DEFAULT: `Establecer por defecto`,
    SETTINGS: `Mi Configuración`,
    SETTLED: `Liquidado`,
    SETTLEMENT_NO_REGISTRATION: `Liquidación Sin Registro`,
    SETUP: `Configuración`,
    SETUP_DATE_IS_REQUIRED: `La fecha de configuración es necesaria.`,
    SETUP_IS_REQUIRED: `La configuración es necesaria.`,
    SGST_UTGST: `SGST/UTGST`,
    SHIP_TO: `Enviar a`,
    SHIPPED: `Enviado`,
    SHIPPING_ID: `ID de envío`,
    SHIPPING_ID_REQUIRED: `ID de envío requerido`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Información de envío/instrucciones especiales`,
    SHIPPING_INSTRUCTIONS: `Instrucciones de Envío`,
    SHORT_TEXT: `Texto corto`,
    SHORT_TEXT_IS_REQUIRED: `Se requiere texto corto`,
    SHOW_ALL: `Mostrar todo ({count})`,
    SHOW_EXCLUDED: `Mostrar Excluidos`,
    SHOW_MORE: `Mostrar más`,
    SHOW_MORE_GROUPS: `Mostrar {countToDisplay} {count, plural, one {grupo más} other {grupos más}}`,
    SHOW_RED_IF_LESS_THAN: `Mostrar en Rojo si es Menor que`,
    SHOW_REIMBURSED_AMOUNT: `Mostrar Cantidad Reembolsada`,
    SHOW_REIMBURSED_PERCENTAGE: `Mostrar Porcentaje Reembolsado`,
    SHOW_YELLOW_IF_LESS_THAN: `Mostrar en Amarillo si es Menor que`,
    SIGN_IN_REQUIRED: `Inicio de sesión requerido`,
    SIGN_OUT: `Desloguearse`,
    SKIP_AUDIT: `Saltar auditoría`,
    SKIP_AUDIT_SUCCESS: `Se ha omitido la auditoría y la fecha de vencimiento está en el futuro.`,
    SOME_PARTS_RETURNED: `Algunas Piezas Devueltas`,
    SORT_BY: `Ordenar Por`,
    SPANISH: `Español`,
    SPECIAL_ALLOWANCE: `Prestación especial`,
    SPECIAL_ALLOWANCE_CALCULATION: `Cálculo de prestación especial`,
    SPECIAL_ALLOWANCE_CLAIM: `Reclamación de prestación especial`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS: `Estado de la reclamación de beneficios especiales`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: `Estado de la reclamación de beneficios especiales`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: `Estado de la reclamación de beneficios especiales actualizado`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID: `Reclamación de prestación especial {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: `Reclamaciones de de prestaciones especiales ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS: `Contribuciones de prestación especial`,
    SPECIAL_ALLOWANCE_DESCRIPTION: `Descripción de prestación especial`,
    SPECIAL_ALLOWANCE_TYPE: `Tipo de prestación especial`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: `Tipo de prestación especial es necesario.`,
    SPECIAL_INSTRUCTIONS: `Instr. Especiales`,
    SPG: `SPG`,
    SPGS: `SPG`,
    STANDARD_VIEW: `Vista estándar`,
    START_AMOUNT_OF_USE: `Inicio cantidad de uso `,
    STARTS: `Comienza`,
    STARTS_WITH: `Comienza con`,
    STATE: `Estado`,
    STATE_PROVINCE: `Estado/Provincia`,
    STATE_PROVINCE_REQUIRED: `Estado/provincia requeridos`,
    STATUS: `Estatus`,
    STATUS_CHANGE_REQUEST: `Cambio de estatus solicitud`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: `Cambio de estatus solicitud creado correctamente `,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY: `Solicitud de estado de la máquina actualizada correctamente`,
    STATUS_FOR: `Estatus para PIN`,
    STATUS_INDICATOR: `Indicador de Estatus`,
    STATUS_REASON: `Razón de Estatus`,
    STOLEN_DATE: `Fecha robada`,
    STORE: `Tienda`,
    STORE_IS_REQUIRED: `La tiendo es necesaria.`,
    STORE_NUMBER_IS_REQUIRED: `El número de tienda es necesario.`,
    STREET_1: `Calle 1`,
    STREET_2: `Calle 2`,
    SUB: `Entregar`,
    SUB_CLAIM_TYPE: `Tipo de Garantía Sustituida`,
    SUB_TYPE: `Subtipo`,
    SUBMISSION_DATE: `Fecha de entrega`,
    SUBMIT: `Enviar/Entregar`,
    SUBMIT_AUDIT: `Enviar Auditoría`,
    SUBMIT_AUDIT_FOR: `Enviar Auditoría Para {dealer}`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Enviar Reclamación de Débito Total para {claimNumber}`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Enviar Reclamación de Débito Parcial para {claimNumber}`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Enviar Reclamación de débito porcentual para {claimNumber}`,
    SUBMIT_REQUEST: `Enviar Solicitud`,
    SUBMITTED: `Enviada`,
    SUBMITTED_AVAILABLE_TO_EDIT: `Enviada (Editable)`,
    SUCCESS: `Éxito`,
    SUCCESS_MESSAGE_TITLE: `La operación se realizó correctamente:`,
    SUCCESS_MESSAGES_TITLE: `Varias operaciones se realizaron correctamente:`,
    SUPPLIER_WARRANTY: `Garantía del Proveedor`,
    SURVEY_QUESTIONS: `Preguntas de la Encuesta`,
    SUSPENDED: `Suspendido`,
    SWEDISH: `Sueco`,
    SYSTEM_SELECTED_CLAIMS: `Reclamaciones Seleccionadas por el Sistema`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT: `Reclamaciones Seleccionadas por el Sistema ({count})`,
    TABM: `TABM`,
    TAX: `Impuestos`,
    TCSM: `TCSM`,
    TCSM_COMMENTS: `Comentarios de TCSM`,
    TCSM_ID: `ID DE TCSM`,
    TECH_ID: `Código Técnico`,
    TERMINATED: `Terminado`,
    TERMINATES: `Termina`,
    TERRITORY: `Territorio`,
    TEST: `Prueba`,
    TEST_RESULTS_CODE: `Código`,
    THEME: `Tema`,
    TIME_LIMIT: `Límite de Tiempo`,
    TIME_ZONE: `Zona Horaria`,
    TITLE: `Título`,
    TITLE_IS_REQUIRED: `Se requiere tTítulo`,
    TO: `a`,
    TODAY: `Hoy`,
    TOO_MANY_RESULTS: `Su solicitud arrojó demasiados resultados. Por favor, reduzca sus términos de búsqueda e inténtelo de nuevo.`,
    TOTAL: `Total`,
    TOTAL_AMOUNT: `Monto Total`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `Total en PLN`,
    TOTAL_APPROVED: `Total Aprobado`,
    TOTAL_APPROVED_CLAIM_VALUE: `Importe Total Aprobado`,
    TOTAL_APPROVED_INCLUDING_TAXES: `Importe total aprobado incluyendo impuestos`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES: `Importe total aprobado sin aditivos`,
    TOTAL_CONTRIBUTION: `Contribución Total`,
    TOTAL_REIMBURSED: `Total Reembolsado`,
    TOTAL_REIMBURSED_WITH_CURRENCY: `Total Reembolsado ({currency})`,
    TOTAL_REQUESTED: `Total solicitado`,
    TOTAL_REQUESTED_CLAIM_VALUE: `Importe Total Solicitado`,
    TOTAL_UNPAID: `Total Sin Pagar`,
    TRACKING_NUMBER: `Número de rastreo`,
    TRANSFER: `Transferir`,
    TRANSFER_ALL: `Transferir todo`,
    TRANSFER_APPROVALS: `Aprobaciones de Transferencia`,
    TRANSFER_APPROVALS_TAB: `Aprobaciones de Transferencia ({count})`,
    TRANSFER_CREATED: `Transferencia Creada`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Transferencia de recomendaciones del concesionario`,
    TRANSFER_REJECTED: `Transferencia rechazada`,
    TRANSFER_UPDATED_SUCCESSFULLY: `Transferencia actualizada correctamente`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Transferir todas las recomendaciones del concesionario`,
    TRANSFERS: `Transferencias`,
    TRAVEL: `Desplazamiento`,
    TURKISH: `Turco`,
    TWO_PERCENT_WITHHOLD_VALUE: `2% retienen valor`,
    TYPE: `Tipo`,
    TYPES: `Tipos`,
    UNABLE_TO_CONTACT_THE_SERVER: `No se puede comunicar con servidor`,
    UNABLE_TO_COPY_ATTACHMENTS: `No hemos podido copiar los archivos adjuntos de la reclamación original, revisa antes de enviar tu nueva reclamación.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS: `No se puede descargar los detalles del cliente`,
    UNDO: `Deshacer`,
    UNDO_REGISTRATION: `Deshacer registro`,
    UNDO_REGISTRATION_SUCCESSFULL: `El registro de Deshacer es exitoso`,
    UNIT: `Unidad`,
    UNIT_1: `Unidad 1`,
    UNIT_2: `Unidad 2`,
    UNIT_3: `Unidad 3`,
    UNIT_OF_MEASURE: `Unidad de Medida`,
    UNPAID_LABOR: `Trabajo Sin Pagar`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: `Aditivos por Mano de Obra Sin Pagar - excluyendo PIPs`,
    UNPAID_LABOR_ADDITIVES_PIPS: `Aditivos por Mano de Obra Sin Pagar - PIP`,
    UNPAID_OTHER_CREDITS: `Otros créditos sin pagar`,
    UNPAID_PARTS: `Piezas Sin Pagar`,
    UNPAID_PARTS_ADDITIVE: `Aditivos por piezas sin pagar`,
    UNPAID_TRAVEL: `Viajes sin pagar`,
    UNRECONCIL: `Desreconciliar`,
    UNRECONCILE_CLAIM : `Desconciliar reclamación`,
    UNSUB: `Editar`,
    UNSUBMIT_CLAIM: `Editar Reclamación`,
    UPDATE: `Actualización`,
    UPDATE_CUSTOMER_INFORMATION: `Actualice información del cliente`,
    UPDATE_LABOR_RATES: `Actualizar costos laborales`,
    UPDATE_LAYOUT: `Diseño de página de actualización`,
    UPDATE_MACHINE_STATUS: `Actualizar estatus de maquina`,
    UPDATE_MACHINE_STATUS_HISTORY: `Actualizar el Historial del Estado de la Máquina`,
    UPDATE_REGISTRATION: `Actualizar registro`,
    UPDATE_SELECTED: `Actualizar selección`,
    UPDATED: `Actualizado`,
    UPDATED_BY: `Actualizado por`,
    UPDATED_DATE_FROM: `Fecha de actualización desde`,
    UPDATED_DATE_TO: `Fecha de actualización hasta`,
    UPLOAD_DOCUMENT: `Subir documento`,
    UPTIME_ASSURANCE: `Seguro de tiempo operativo`,
    USEFUL_LINKS: `Enlaces Útiles`,
    USER: `usuario`,
    USER_PREFERENCES_UPDATED: `Preferencias del usuario actualizadas`,
    USER_SELECTED: `Usuario Seleccionado`,
    USER_SELECTED_CLAIMS_WITH_COUNT: `Reclamaciones Seleccionadas por el Usuario ({count})`,
    USERS_INFORMATION: `Información de usuarios`,
    VALIDATE: `Validar`,
    VALIDATE_CLAIM: `Validar Reclamación`,
    VALUE: `Valor`,
    VALUE_OF_REPAIR: `Valor de Reparación`,
    VIEW_CLAIM: `Ver Reclamación`,
    VIEW_DETAILS: `Ver Detalles`,
    VIEW_OPEN_PIPS: `Ver PIP Abiertos`,
    VIEW_PIP: `Ver PIP`,
    VIEW_PRODUCTS: `Ver productos`,
    VIEW_PRODUCTS_AND_UPDATE_INFO: `Ver productos y Actualizar Información`,
    VIEW_UPDATE: `Ver/Actualizar`,
    VSR_MESSAGES: `Mensajes VSR`,
    WAITING_FOR_DLR_INV: `Esperando factura de distribuidor`,
    WAITING_FOR_INVOICE: `Esperando factura ({count})`,
    WAITING_SINCE: `Esperando desde`,
    WARNING_MESSAGE_TITLE: `Se envió una advertencia:`,
    WARNING_MESSAGES: `Mensajes de Advertencia`,
    WARNING_MESSAGES_TITLE: `Se enviaron varias advertencias:`,
    WARRANTY: `Garantía`,
    WARRANTY_ADMIN: `Garantía Administrador`,
    WARRANTY_CLAIM_TYPE: `Tipo de reclamación de garantía`,
    WARRANTY_COVERAGE: `Cobertura de Garantía`,
    WARRANTY_EXPIRATION: `Vencimiento de la Garantía`,
    WARRANTY_TYPE: `Tipo de Garantía`,
    WARRANTY_TYPES: `Tipos de Garantía`,
    WEAR_PARTS: `Piezas de desgaste`,
    WEAR_PARTS_COVERAGE: `Cobertura de piezas de desgaste`,
    WELCOME: `Bienvenido`,
    WINTERIZATION: `Preparación para invierno`,
    WIP: `Trabajo en Progreso`,
    WITH_ADDITIVES: `Con Aditivos`,
    WITNESS_FIRST_NAME: `Nombre del Testigo`,
    WITNESS_LAST_NAME: `Apellido del Testigo`,
    WORK_ORDER: `Orden de trabajo`,
    WORK_ORDER_NUMBER: `Número de orden de trabajo`,
    WORK_ORDER_ONE: `Orden de trabajo 1`,
    WORK_ORDER_ONE_IS_REQUIRED: `El orden de trabajo es necesario.`,
    WORK_ORDER_THREE: `Orden de trabajo 3`,
    WORK_ORDER_THREE_IS_REQUIRED: `El orden de trabajo 3 es necesario.`,
    WORK_ORDER_TWO: `Orden de trabajo 2`,
    WORK_REPAIR_ORDER: `Orden de reparación de trabajo`,
    YES: `Sí`,
    YES_LOWERCASE: `Sí`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/es.js